const MODULE_NAME = "ADHERENCE_EVENTS_MODULE_";
const ADHERENCE_EVENTS_FETCH_STARTED = MODULE_NAME + 'ADHERENCE_FETCH_STARTED';
const ADHERENCE_EVENTS_FETCH_COMPLETED = MODULE_NAME + 'ADHERENCE_FETCH_COMPLETED';

export {
  ADHERENCE_EVENTS_FETCH_STARTED,
  ADHERENCE_EVENTS_FETCH_COMPLETED
};
